import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Select,
  Modal,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import { FileIcon } from "@shopify/polaris-icons";
import Select2 from "react-select";
import { MultiSelect } from "primereact/multiselect";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";

const AddEditSubpackage = (props) => {
  const navigate = useNavigate();
  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/[\s_-]+/g, "-")
      .replace(/^-+|-+$/g, "");
  const { id, subpackageId } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const imageKey = useRef("");
  const logoKey = useRef("");
  const videoKey = useRef("");
  const editor = useRef(null);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [item, setItem] = useState({
    title: "",
    gender: "",
    isActive: true,
    description: "",
    price: "",
    expiry: "",
    expiry_frequency: "",
    classes: [],
    free_bookings_count: "",
    elements: [],
    gender: "",
    capacity_female: "",
    capacity_male: "",
    total_capacity: "",
  });

  const handleChangeTitle = (newValue) => {
    setItem({ ...item, title: newValue });
    setTitleError("");
  };
  const [titleError, setTitleError] = useState("");
  const handleChangeFreeBookingsCount = (newValue) => {
    setItem({ ...item, free_bookings_count: newValue });
    setFreeBookingsCountError("");
  };
  const [freeBookingsCountError, setFreeBookingsCountError] = useState("");
  const handleChangeExpiry = (newValue) => {
    setItem({ ...item, expiry: newValue });
    setExpiryError("");
  };
  const [expiryError, setExpiryError] = useState("");
  const handleChangeExpiryFrequency = (newValue) => {
    setItem({ ...item, expiry_frequency: newValue });
    setExpiryFrequencyError("");
  };
  const [expiryFrequencyError, setExpiryFrequencyError] = useState("");
  const handleChangePrice = (newValue) => {
    setItem({ ...item, price: newValue });
    setPriceError("");
  };
  const [priceError, setPriceError] = useState("");
  const handleChangeDescription = (newValue) => {
    setItem({ ...item, description: newValue });
  };
  const handleChangeGender = (newValue) => {
    setItem({ ...item, gender: newValue });
    setGenderError("");
  };
  const [genderError, setGenderError] = useState("");
  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };
  const [files, setFiles] = useState([]);
  const handleDropZone = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );
  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
  const fileUpload = !files.length && (
    <DropZone.FileUpload actionHint={"Accepts jpegs and pngs"} />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const sendImage = (files) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "news");
    form_data.append("image", files[files.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data;
        setIsImageUploading(false);
        setItem({
          ...item,
          image:
            validImageTypes.indexOf(files[files.length - 1].type) > 0
              ? window.URL.createObjectURL(files[files.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
        setImageError("");
      })
      .catch(function (error) {});
  };

  const [filesVideo, setFilesVideo] = useState([]);
  const handleDropZoneVideo = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesVideo((filesVideo) => [...filesVideo, ...acceptedFiles]),
    []
  );
  const fileUploadVideo = !filesVideo.length && (
    <DropZone.FileUpload actionHint={"Accepts mp4"} />
  );
  const uploadedFilesVideo = filesVideo.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(filesVideo[filesVideo.length - 1].type)
              ? window.URL.createObjectURL(filesVideo[filesVideo.length - 1])
              : NoteIcon
          }
        />
        <div>
          {filesVideo[filesVideo.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {filesVideo[filesVideo.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const sendVideo = (filesVideo) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "intro_content");
    form_data.append("video", filesVideo[filesVideo.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        videoKey.current = result.data.data;
        setIsImageUploading(false);
        setItem({
          ...item,
          video:
            validImageTypes.indexOf(filesVideo[filesVideo.length - 1].type) > 0
              ? window.URL.createObjectURL(filesVideo[filesVideo.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };

  const [filesLogo, setFilesLogo] = useState([]);
  const handleDropZoneLogo = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesLogo((filesLogo) => [...filesLogo, ...acceptedFiles]),
    []
  );
  const fileUploadLogo = !filesLogo.length && (
    <DropZone.FileUpload
      actionHint={
        "Accepts svgs, jpegs and pngs (Required size: 200x200 pixels)"
      }
    />
  );
  const uploadedFilesLogo = filesLogo.length > 0 && (
    <div style={{ padding: "0" }}>
      {filesLogo.map((file, index) => (
        <div key={index} className="rowDiv">
          <Thumbnail
            size="small"
            alt={file.title}
            source={
              validImageTypes.includes(file.type)
                ? window.URL.createObjectURL(file)
                : NoteIcon
            }
          />
          <div>
            {file.title}{" "}
            <Text variant="bodySm" as="p">
              {file.size} bytes
            </Text>
          </div>
        </div>
      ))}
    </div>
  );
  const sendImageLogo = (filesLogo) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "intro_content");
    form_data.append("image", filesLogo[filesLogo.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        logoKey.current = result.data.data;
        setIsImageUploading(false);
        setItem({
          ...item,
          logo:
            validImageTypes.indexOf(filesLogo[filesLogo.length - 1].type) > 0
              ? window.URL.createObjectURL(filesLogo[filesLogo.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };
  const [imageError, setImageError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  const [optionsClasses, setOptionsClasses] = useState([]);
  const handleSelectChangeClass = (newValue) => {
    setItem({ ...item, classes: newValue });
    setClassError("");
  };
  const [optionsElements, setOptionsElements] = useState([]);
  const [classError, setClassError] = useState("");
  const optionsGenders = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
    { label: "Mixed (With male,female capacities)", value: "mixed" },
    { label: "Mixed (With total capacity)", value: "mixed_total" },
  ];
  const handleSelectChangeGender = (newValue) => {
    setItem({ ...item, gender: newValue });
    setGenderError("");
  };
  const handleChangeCapacityMale = (newValue) => {
    setItem({ ...item, capacity_male: newValue });
    setMaleCapacityError("");
  };
  const [maleCapacityError, setMaleCapacityError] = useState("");
  const handleChangeCapacityFemale = (newValue) => {
    setItem({ ...item, capacity_female: newValue });
    setFemaleCapacityError("");
  };
  const [femaleCapacityError, setFemaleCapacityError] = useState("");
  const handleChangeCapacityTotal = (newValue) => {
    setItem({ ...item, total_capacity: newValue });
    setTotalCapacityError("");
  };
  const [totalCapacityError, setTotalCapacityError] = useState("");
  useEffect(() => {
    fetchData();
  }, []);
  const [ts, setTs] = useState("");
  useEffect(() => {
    axios
      .get(`/classes-list-by-element?element_ids=${item.elements.join(",")}`)
      .then((result) => {
        console.log(result.data.data);
        setItem({
          ...item,
          classes: result.data.data.map((item) => String(item.id)),
        });
      })
      .catch((err) => console.log(err));
  }, [ts]);

  async function fetchData() {
    let responseItem = "";
    let responseClasses = [];
    let responseElements = [];
    try {
      responseClasses = await axios.get(`/classes-list`);
      setOptionsClasses(
        responseClasses.data.data.map((item, index) => {
          return {
            label: item.name,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
    try {
      responseElements = await axios.get(`/elements`);
      setOptionsElements(
        responseElements.data.data.data.map((item, index) => {
          return {
            label: item.title,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
    if (props.type === "edit") {
      try {
        responseItem = await axios.get(
          `/packages/${id}/subpackages/${subpackageId}`
        );
        setItem({
          title: responseItem?.data?.data?.name
            ? responseItem.data.data.name
            : "",
          description: responseItem?.data?.data?.description
            ? responseItem.data.data.description
            : "",
          expiry: responseItem?.data?.data?.expiry_duration
            ? String(responseItem.data.data.expiry_duration)
            : "",
          expiry_frequency: responseItem?.data?.data?.expiry_frequency
            ? responseItem.data.data.expiry_frequency
            : "",
          free_bookings_count:
            responseItem?.data?.data?.free_bookings_count !== null
              ? String(responseItem.data.data.free_bookings_count)
              : "",
          price:
            responseItem?.data?.data?.price !== null
              ? String(responseItem.data.data.price)
              : "",
          elements:
            responseItem?.data?.data?.elements &&
            responseItem?.data?.data?.elements.length
              ? responseItem?.data?.data?.elements.map((item) =>
                  String(item.id)
                )
              : [],
          classes:
            responseItem?.data?.data?.classes &&
            responseItem?.data?.data?.classes.length
              ? responseItem?.data?.data?.classes.map((item) => String(item.id))
              : [],
          gender: responseItem?.data?.data?.gender
            ? responseItem.data.data.gender
            : "",
          capacity_female:
            responseItem?.data?.data?.capacity_female !== "" &&
            responseItem?.data?.data?.capacity_female !== null
              ? responseItem.data.data.capacity_female
              : "",
          capacity_male:
            responseItem?.data?.data?.capacity_male !== "" &&
            responseItem?.data?.data?.capacity_male !== null
              ? responseItem.data.data.capacity_male
              : "",
          total_capacity:
            responseItem?.data?.data?.capacity !== "" &&
            responseItem?.data?.data?.capacity !== null
              ? responseItem.data.data.capacity
              : "",
          isActive: responseItem?.data?.data?.is_active ? true : false,
        });
      } catch (error) {
        console.log(error);
      }
    }

    setIsSaving(false);
  }
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/packages/${id}/subpackages/${subpackageId}`)
      .then((result) => {
        navigate(`/admin/packages/${id}/subpackages`);
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Option`}
      backAction={{
        onAction: () => navigate(`/admin/packages/${id}/subpackages`),
      }}
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              value={item.title}
              onChange={handleChangeTitle}
              label="Name"
              error={titleError}
            />
            <TextField
              value={item.price}
              onChange={handleChangePrice}
              label="Price"
              error={priceError}
              type="number"
            />
          </FormLayout.Group>

          <FormLayout.Group>
            <Select
              label="Expiry Frequency"
              options={[
                { label: "Days", value: "days" },
                { label: "Weeks", value: "weeks" },
                { label: "Months", value: "months" },
                { label: "Years", value: "years" },
              ]}
              onChange={handleChangeExpiryFrequency}
              value={item.expiry_frequency}
              placeholder="Please select"
              error={expiryFrequencyError}
            />
            <TextField
              value={item.expiry}
              onChange={handleChangeExpiry}
              label="Expiry Duration"
              error={expiryError}
              type="number"
            />
          </FormLayout.Group>
          <TextField
            value={item.free_bookings_count}
            onChange={handleChangeFreeBookingsCount}
            label="Free Bookings Number"
            error={freeBookingsCountError}
            type="Number"
          />
          <TextField
            value={item.description}
            onChange={handleChangeDescription}
            label="Description"
          />

          <Select
            label="Gender"
            options={optionsGenders}
            onChange={handleSelectChangeGender}
            value={item.gender}
            placeholder="Please select"
            error={genderError}
          />
          {(item.gender === "male" || item.gender === "mixed") && (
            <TextField
              value={item.capacity_male}
              onChange={handleChangeCapacityMale}
              label="Male Capacity"
              error={maleCapacityError}
              type="number"
            />
          )}
          {(item.gender === "female" || item.gender === "mixed") && (
            <TextField
              value={item.capacity_female}
              onChange={handleChangeCapacityFemale}
              label="Female Capacity"
              error={femaleCapacityError}
              type="number"
            />
          )}
          {item.gender === "mixed_total" && (
            <TextField
              value={item.total_capacity}
              onChange={handleChangeCapacityTotal}
              label="Total Capacity"
              error={totalCapacityError}
              type="number"
            />
          )}

          <Text>Elements</Text>
          <MultiSelect
            value={item.elements}
            options={optionsElements}
            onChange={(e) => {
              console.log(e.value);
              setItem({ ...item, elements: e.value });
              setTs(+new Date());
            }}
            filter={true}
            placeholder="Please select"
            style={{ width: "100%" }}
            selectAllLabel="Select All"
            display="chip"
          />
          {/* <Select
            label="Element"
            options={optionsElements}
            onChange={handleSelectChangeElement}
            value={item.element}
            placeholder="Please select"
          /> */}
          <Text>Classes</Text>
          {/* <Select2
            options={optionsClasses}
            onChange={handleSelectChangeClass}
            value={item.classes}
            placeholder="Please select"
            styles={{
              // Fixes the overlapping problem of the compont
              menu: (provided) => ({ ...provided, zIndex: 9999 }),
            }}
            isMulti
          /> */}

          <MultiSelect
            value={item.classes}
            options={optionsClasses}
            onChange={(e) => {
              console.log(e.value);
              setItem({ ...item, classes: e.value });
            }}
            filter={true}
            placeholder="Please select"
            style={{ width: "100%" }}
            selectAllLabel="Select All"
            display="chip"
            // panelFooterTemplate={
            //   <Button onClick={() => setItem({ ...item, classes: [] })}>
            //     Clear All
            //   </Button>
            // }
          />

          <InlineError message={classError} />
          <Button onClick={() => setItem({ ...item, classes: [] })}>
            Clear all classes
          </Button>
          {/* <div style={{ height: "200px" }}></div> */}
          {/* <Select
            label="Gender"
            options={[
              { label: "Male", value: "male" },
              { label: "Female", value: "female" },
              { label: "Mixed", value: "mixed" },
            ]}
            onChange={handleChangeGender}
            value={item.gender}
            placeholder="Please select"
            error={genderError}
          /> */}

          <Checkbox
            label="Is active"
            checked={item.isActive}
            onChange={handleChangeActive}
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => setActiveDelete(true)}
            >
              Delete
            </Button>
          )
        }
      />
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    console.log(item.classes);
    if (
      !item.title ||
      !item.expiry ||
      item.free_bookings_count === "" ||
      !item.price ||
      !item.classes.length ||
      !item.expiry_frequency ||
      !item.gender ||
      ((item.gender === "male" || item.gender === "mixed") &&
        item.capacity_male === "") ||
      ((item.gender === "female" || item.gender === "mixed") &&
        item.capacity_female === "") ||
      (item.gender === "mixed_total" && item.total_capacity === "")
    ) {
      !item.title && setTitleError("This field is required");
      !item.expiry && setExpiryError("This field is required");
      item.free_bookings_count === "" &&
        setFreeBookingsCountError("This field is required");
      !item.price && setPriceError("This field is required");
      !item.classes.length && setClassError("Please select classes");
      !item.expiry_frequency &&
        setExpiryFrequencyError("Please select an option");

      !item.gender && setGenderError("Please choose an option");
      (item.gender === "male" || item.gender === "mixed") &&
        item.capacity_male === "" &&
        setMaleCapacityError("This field is required");
      (item.gender === "female" || item.gender === "mixed") &&
        item.capacity_female === "" &&
        setFemaleCapacityError("This field is required");
      item.gender === "mixed_total" &&
        item.total_capacity === "" &&
        setTotalCapacityError("This field is required");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      form_data.append("name", item.title);
      form_data.append("price", item.price);
      form_data.append("description", item.description);
      form_data.append("free_bookings_count", item.free_bookings_count);
      form_data.append("expiry_duration", item.expiry);
      form_data.append("expiry_frequency", item.expiry_frequency);
      form_data.append("gender", item.gender);
      (item.gender === "male" || item.gender === "mixed") &&
        form_data.append("capacity_male", item.capacity_male);
      (item.gender === "female" || item.gender === "mixed") &&
        form_data.append("capacity_female", item.capacity_female);
      item.gender === "mixed_total" &&
        form_data.append("capacity", item.total_capacity);
      item.elements.length &&
        item.elements.forEach((selected, index) =>
          form_data.append(`element_ids[${index}]`, selected)
        );
      item.classes.forEach((selected, index) =>
        form_data.append(`classes[${index}]`, selected)
      );
      form_data.append("is_active", item.isActive ? 1 : 0);
      props.type === "edit" && form_data.append("_method", "PATCH");

      props.type === "add"
        ? axios
            .post(`/packages/${id}/subpackages`, form_data)
            .then((result) => {
              navigate(`/admin/packages/${id}/subpackages`);
            })
            .catch((err) => console.log(err))
        : axios
            .post(`/packages/${id}/subpackages/${subpackageId}`, form_data)
            .then((result) => {
              toggleActive();
              setIsSaving(false);
            })
            .catch((err) => console.log(err));
    }
  }
};

export default AddEditSubpackage;
